import React from 'react';
import { Navbar } from '../components/Navbar';
import { DonorRecognitionPage } from '../components/DonorRecognitionPage';
import { Footer } from '../components/Footer';
export const DonorRecognition = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2345" data-mp="y5mfyjllnpa3">
      <Navbar data-id="element-2346" data-mp="12xdzwba92wr9" />
      <DonorRecognitionPage data-id="element-2347" data-mp="12xxh1ps2th48" />
      <Footer data-id="element-2348" data-mp="12y5vvn7rewi2" />
    </div>;
};